const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
// Ühekordne session UUID – seotud brauseriga, mitte kasutajaga (GDPR-ohutu)
function getSessionId() {
  let sid = localStorage.getItem('sid');
  if (!sid) {
    sid = crypto.randomUUID();
    localStorage.setItem('sid', sid);
  }
  return sid;
}

function getDevice() {
  const w = window.innerWidth;
  if (w < 768) return 'mobile';
  if (w < 1024) return 'tablet';
  return 'desktop';
}

function getBrowser() {
  const ua = navigator.userAgent;
  if (ua.includes('Firefox')) return 'Firefox';
  if (ua.includes('Edg')) return 'Edge';
  if (ua.includes('Chrome')) return 'Chrome';
  if (ua.includes('Safari')) return 'Safari';
  return 'other';
}

function getUtm() {
  const params = new URLSearchParams(window.location.search);
  const source = params.get('utm_source');
  const campaign = params.get('utm_campaign');
  const content = params.get('utm_content');
  if (source) localStorage.setItem('utm_source', source);
  if (campaign) localStorage.setItem('utm_campaign', campaign);
  if (content) localStorage.setItem('utm_content', content);
  return {
    utm_source: localStorage.getItem('utm_source') || null,
    utm_campaign: localStorage.getItem('utm_campaign') || null,
    utm_content: localStorage.getItem('utm_content') || null,
  };
}

export function trackEvent(event, options = {}) {
  const { value, duration_ms } = options;
  const utm = getUtm();

  const payload = {
    session_id: getSessionId(),
    user_id: options.user_id || null,
    event,
    language: localStorage.getItem('language') || 'en',
    device: getDevice(),
    browser: getBrowser(),
    screen_width: window.innerWidth,
    referrer: document.referrer || null,
    value: value ?? null,
    duration_ms: duration_ms ?? null,
    utm_source: utm.utm_source,
    utm_campaign: utm.utm_campaign,
    utm_content: utm.utm_content,
  };

  // Fire-and-forget – ei blokeeri UI-d
  fetch(API_URL + '/api/stats/event', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).catch(() => {}); // vaikne ebaõnnestumine
}

// Web Vitals mõõtmine (LCP/FCP/TTFB) — et näha PH/mobiili tegelikku laadimisaega.
// Salvestab olemasolevasse stats-mustrisse: event='web_vitals', value=meetriku nimi
// ('LCP'/'FCP'/'TTFB'), duration_ms=mõõdetud millisekundid. Serverit muuta pole vaja.
// web-vitals laetakse dünaamiliselt, et see ei suurendaks main-bundle't.
export function trackWebVitals() {
  import('web-vitals')
    .then(({ getLCP, getFCP, getTTFB }) => {
      const send = (metric) => {
        trackEvent('web_vitals', { value: metric.name, duration_ms: Math.round(metric.value) });
      };
      getLCP(send);
      getFCP(send);
      getTTFB(send);
    })
    .catch(() => {}); // vaikne ebaõnnestumine (nt web-vitals laadimine ebaõnnestus)
}
